<template>
  <el-dialog
    v-if="visible"
    :title="exampleTitle[type].title"
    :visible.sync="visible"
    width="800px"
    :before-close="handleClose"
  >
    <h2>
      <div class="title">
        <p v-for="(item, index) in exampleTitle[type].content" :key="index + 'tit'">
          <span>{{ item.label }}</span>
          <span v-if="item.type" v-html="item.value"></span>
          <template v-else> {{ item.value }}</template>
        </p>
        <p class="title-tip" v-if="exampleTitle[type].tip">
          <img src="@/assets/img/icon_tip.png" alt="" />
          <span>{{ exampleTitle[type].tip }}</span>
        </p>
      </div>
    </h2>
    <ul class="content">
      <li v-for="(item, index) in exampleData[type]" :key="index">
        <p class="tit">{{ item.title }}</p>
        <p class="salary">
          <span>{{ item.label }}</span>
          <span>{{ item.value }}</span>
        </p>
        <div class="date" v-if="item.date && item.date.length">
          <div v-for="(date, index) in item.date" :key="index + '_date'">
            <p class="date-title">{{ date.date }}</p>
            <div class="week">
              <span v-for="(week, index) in weeks" :key="index + '_week'">{{ week }}</span>
            </div>
            <div class="days">
              <p class="day"></p>
              <p class="day"></p>
              <template v-if="date.day === 30">
                <p class="day"></p>
                <p class="day"></p>
                <p class="day"></p
              ></template>
              <p class="day" v-for="day in date.day" :key="day + 'day'">
                <span
                  :class="{
                    success: day >= date.data_min && day <= date.data_max,
                    error: day >= date.before_min && day <= date.before_max
                  }"
                >
                  {{ day >= 10 ? day : '0' + day }}
                  <i
                    :class="{
                      hire: day === (date.hire || date.salary),
                      leave: day === date.leave,
                      definition: day >= date.day_min && day <= date.day_max
                    }"
                  ></i>
                </span>
              </p>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('652') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { exampleTitle, exampleData } from './config.js'
export default {
  data() {
    return {
      type: '', // 1周期内有入职，无离职 2周期内无入职，有离职
      visible: false,
      exampleTitle: exampleTitle(this),
      exampleData: exampleData(this),
      weeks: [
        this.$t('1121'),
        this.$t('1122'),
        this.$t('1123'),
        this.$t('1124'),
        this.$t('1125'),
        this.$t('1126'),
        this.$t('1127')
      ]
    }
  },
  methods: {
    init(type) {
      this.type = Number(type) - 1
      this.visible = true
    },
    handleClose() {
      this.visible = false
    }
  }
}
</script>
<style lang="scss">
.holidays {
  font-weight: 600;
  color: red;
  padding: 0 3px;
}
.size {
  font-weight: 600;
  color: #535454;
}
</style>

<style lang="scss" scoped>
h2 {
  .title {
    background: #f7f8fa;
    border-radius: 4px;
    padding: 12px;
    &.p {
      color: #262626;
      span {
        color: #595959;
      }
    }
    &-tip {
      color: #8c8c8c;
      img {
        width: 16px;
        padding-right: 3px;
      }
    }
  }
  p {
    font-weight: 400;
    font-size: 14px;
    padding: 5px 0;
  }
}
.content {
  li {
    padding-bottom: 15px;
  }
  .tit {
    font-weight: 500;
    font-weight: 500;
    font-size: 14px;
    color: #262626;
    padding-bottom: 8px;
  }
  .salary {
    padding-bottom: 8px;
  }
  .date {
    height: 255px;
    border: 1px dashed #b6b6b6;
    display: flex;
    justify-content: space-between;
    padding: 18px;
    margin-bottom: 20px;
    &-left,
    &-right {
      width: 360px;
    }

    &-title {
      text-align: center;
      padding-bottom: 10px;
    }
    .week {
      span {
        width: 13%;
        display: inline-block;
        text-align: center;
      }
    }
    .days {
      display: flex;
      flex-wrap: wrap;
      p {
        width: 13%;
        text-align: center;
        margin-top: 10px;
        .error {
          background: #fde2e2;
          border-radius: 50%;
        }
        .success {
          background: #e1f3d8;
          border-radius: 50%;
        }
        span {
          display: inline-block;
          width: 20px;
          height: 20px;
          text-align: center;
          padding-top: 3px;
          position: relative;
          .hire {
            background: #67c23a;
          }
          .leave {
            background: #f56c6c;
          }
          .definition {
            background: #409eff;
          }
          i {
            position: absolute;
            left: 50%;
            bottom: 0;
            width: 4px;
            height: 4px;
            border-radius: 50%;
            margin-left: -2px;
          }
        }
      }
    }
  }
}
</style>
